module.exports = __webpack_public_path__ + "img/1017.f7577c28.jpg";